/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorization } from './PalAuthorization';
import {
    PalAuthorizationFromJSON,
    PalAuthorizationFromJSONTyped,
    PalAuthorizationToJSON,
} from './PalAuthorization';

/**
 * 
 * @export
 * @interface FindOnePalAuthorization200Response
 */
export interface FindOnePalAuthorization200Response {
    /**
     * 
     * @type {PalAuthorization}
     * @memberof FindOnePalAuthorization200Response
     */
    data?: PalAuthorization;
}

/**
 * Check if a given object implements the FindOnePalAuthorization200Response interface.
 */
export function instanceOfFindOnePalAuthorization200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindOnePalAuthorization200ResponseFromJSON(json: any): FindOnePalAuthorization200Response {
    return FindOnePalAuthorization200ResponseFromJSONTyped(json, false);
}

export function FindOnePalAuthorization200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePalAuthorization200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PalAuthorizationFromJSON(json['data']),
    };
}

export function FindOnePalAuthorization200ResponseToJSON(value?: FindOnePalAuthorization200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PalAuthorizationToJSON(value.data),
    };
}

